import type { LiabilityTypeName } from './generated/gql-enums';

export const LIABILITY_TYPE_AUTO = 'auto' satisfies LiabilityTypeName;
export const LIABILITY_TYPE_COMMERCIAL = 'commercial' satisfies LiabilityTypeName;
export const LIABILITY_TYPE_CONSUMER = 'consumer' satisfies LiabilityTypeName;
export const LIABILITY_TYPE_GENERAL = 'general' satisfies LiabilityTypeName;
export const LIABILITY_TYPE_HOME_EQUITY = 'home_equity' satisfies LiabilityTypeName;
export const LIABILITY_TYPE_LINE_OF_CREDIT = 'line_of_credit' satisfies LiabilityTypeName;
export const LIABILITY_TYPE_MORTGAGE = 'mortgage' satisfies LiabilityTypeName;
export const LIABILITY_TYPE_OTHER = 'other' satisfies LiabilityTypeName;
export const LIABILITY_TYPE_STUDENT = 'student' satisfies LiabilityTypeName;
